import dayjs from 'dayjs'

const isNotBlockedDate = (blockedDate, date) =>{
  return !blockedDate.includes(dayjs(date).format("YYYY-MM-DD"))
}


export default isNotBlockedDate
